import { data } from '../../svg/Heading/data';
import { makeIcon } from '../makeIcon';

export const Heading = makeIcon(data, 'heading', 'Heading');

export default Heading;
